export const scrollToError = (selector = '.is-invalid') => {
  const dom = document.querySelector(selector)
  if (!dom) return

  dom.scrollIntoView({ behavior: 'smooth' })
}
